import { cva } from 'class-variance-authority';

import { CONTROL_SIZES, RADIUS_SCALE, INTERACTIVE_STATES, COLOR_SCALE } from './tokens.ts';

const radiusScale = {
  sm: `${RADIUS_SCALE.sm}`,
  md: `${RADIUS_SCALE.md}`,
  lg: `${RADIUS_SCALE.lg}`,
  full: RADIUS_SCALE.full,
};

const widthScale = {
  true: 'w-full',
  false: 'w-auto',
};

const FIELD_BASE_CLASSES = `${COLOR_SCALE['field-border']} ${COLOR_SCALE['field-bg']} text-sm leading-5 tracking-tight ${COLOR_SCALE['field-text']} transition-colors ${INTERACTIVE_STATES.duration.normal} ${COLOR_SCALE['field-placeholder']} ${COLOR_SCALE['field-focus-border']} ${INTERACTIVE_STATES.focus.ring.replace('ring-primary/40', COLOR_SCALE['field-focus-ring'])} ${INTERACTIVE_STATES.focus.offset.replace('ring-offset-2', 'ring-offset-1')} ${INTERACTIVE_STATES.disabled.cursor} ${INTERACTIVE_STATES.disabled.opacity}`;

function createFieldControl(additionalClasses = '') {
  return cva(`${FIELD_BASE_CLASSES} ${additionalClasses}`.trim(), {
    variants: {
      size: {
        sm: CONTROL_SIZES.field.sm,
        md: CONTROL_SIZES.field.md,
        lg: CONTROL_SIZES.field.lg,
      },
      radius: radiusScale,
      fullWidth: widthScale,
    },
    defaultVariants: {
      size: 'md',
      radius: 'md',
      fullWidth: true,
    },
  });
}

export { createFieldControl };
